import axios from 'axios';
import React, {useEffect, useState} from 'react';
import { url } from '../../../Config';
import { useParams } from "react-router-dom";
import Box from '@mui/material/Box';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';



export default function Fund_facts(props) {

    const [data, setdata] = useState([]);
    const { id, record_id } = useParams();
    const [bool, setbool] = useState(false);
    const [alertopen, setalertOpen] = useState(false);
    const [alertType, setalertType] = useState();
    const [AlertMessage, setalertmessage] = useState();
    const [fund_name, setfund_name] = useState("");
    const [fund_category, setfund_category] = useState("");
    const [launch_date, setlaunch_date] = useState("");
    const [fund_size, setfund_size] = useState("");
    const [fund_manager, setfund_manager] = useState("");
    const [fund_risk_profile, setfund_risk_profile] = useState("");
    const [fund_benchmark, setfund_benchmark] = useState("");
    const [fund_objective, setfund_objective] = useState("");
    const userid = localStorage.getItem("userID");
    


    useEffect(()=>{

        const func = async ()=>{

            const res = await axios.get(`${url}/api/get_fund_facts_data/${id}`);
            const resp = res.data;
            if(resp.length > 0){
                setfund_name(resp[0].name);
                setfund_category(resp[0].fund_category);
                setlaunch_date(resp[0].launch_date);
                setfund_size(resp[0].fund_size);
                setfund_manager(resp[0].fund_manager);
                setfund_risk_profile(resp[0].fund_risk_profile);
                setfund_benchmark(resp[0].fund_benchmark);
                setfund_objective(resp[0].fund_objective);
                setdata(resp);

            }
        }

        func();

    },[bool])

    const update = async (event)=>{

        event.preventDefault();

        const res = await axios.post(`${url}/api/edit_fund_facts`,{
            'id': id, 'record_id': record_id, 'userid': Number(userid), 'fund_category' : fund_category, 'launch_date' : launch_date,
            'fund_size' : fund_size, 'fund_manager' : fund_manager, 'fund_risk_profile' : fund_risk_profile,
            'fund_benchmark' : fund_benchmark, 'fund_objective' : fund_objective
        });

         const resp = res.data;
        if(resp.status == true){
            setalertOpen(true);
            setalertmessage(resp.message);
            setalertType("success");
        }
        else{
            setalertOpen(true);
            setalertmessage(resp.message);  
            setalertType("error")
        }
    }

  return (
    <div style={props.screenWidth > 760 ? {height : '90vh'} : null}>
      <div className='text-center mt-2 fs-4 fw-bold' style={{color: "#000078" }}>Fund Facts Form</div>
       <form className='col-10 card p-3 mx-auto mt-lg-4 mt-md-4 mt-2' onSubmit={(event)=>{update(event)}}>
        <div className='mt-2 fw-bold'>
            Fund Name:
        </div>
        <div className='mt-2'>
            <input className='form-control' value={fund_name} disabled />
        </div>
        <div className='mt-2 fw-bold'>
            Fund Category:
        </div>
        <div className='mt-2'>
            <input className='form-control' value={fund_category} onChange={(e)=>{setfund_category(e.target.value)}} />
        </div>
        <div className='mt-2 fw-bold'>
            Launch Date:
        </div>
        <div className='mt-2'>
            <input className='form-control' type='date' value={launch_date} onChange={(e)=>{setlaunch_date(e.target.value)}} />
        </div>
        <div className='mt-2 fw-bold'>
            Fund Size (AUMs): 
        </div>
        <div className='mt-2'>
            <input className='form-control' value={fund_size} onChange={(e)=>{setfund_size(e.target.value)}}/>
        </div>
        <div className='mt-2 fw-bold'>
            Fund Manager:
        </div>
        <div className='mt-2'>
            <input className='form-control' value={fund_manager} onChange={(e)=>{setfund_manager(e.target.value)}} />
        </div>
        <div className='mt-2 fw-bold'>
            Fund Risk Profile:
        </div>
        <div className='mt-2'>
            <input className='form-control' value={fund_risk_profile} onChange={(e)=>{setfund_risk_profile(e.target.value)}}/>
        </div>
        <div className='mt-2 fw-bold'>
            Fund Benchmark:
        </div>
        <div className='mt-2'>
            <input className='form-control' value={fund_benchmark} onChange={(e)=>{setfund_benchmark(e.target.value)}}/>
        </div>
        <div className='mt-2 fw-bold'>
            Fund Objective:
        </div>
        <div className='mt-2'>
            <textarea className='form-control' value={fund_objective} onChange={(e)=>{setfund_objective(e.target.value)}}/>
        </div>
        <div>
            <Box className="mx-auto mb-1 mt-1" sx={{ width: "98%" }}>
                              <Collapse in={alertopen}>
                                  <Alert
                                  severity={alertType}
                                  action={
                                      <IconButton
                                      aria-label="close"
                                      color="inherit"
                                      size="small"
                                      onClick={() => {
                                          setalertOpen(false);
                                      }}
                                      >
                                      <CloseIcon fontSize="inherit" />
                                      </IconButton>
                                  }
                                  sx={{ mb: 2 }}
                                  >
                                  {AlertMessage}
                                  </Alert>
                              </Collapse>
            </Box> 
        </div>
        <div className='mt-2'>
            {data.length >  0 && <button className='btn btn-primary' type='submit'>Submit</button>}
        </div>
        </form>
      </div>
  )
}
